import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    selectedScheduleCall: null,

    councilorList:[]
};

const scheduleCall = createSlice({
    name: 'scheduleCall',
    initialState,
    reducers: {
        setSelectedScheduleCall(state, action) {
            state.selectedScheduleCall = action?.payload
        },

        // councilor
        setCouncilorList(state,action){
            state.councilorList = action?.payload
        }
    },
});

export const {
    setSelectedScheduleCall,

    setCouncilorList
} = scheduleCall.actions;
export default scheduleCall.reducer;
